__webpack_require__.p = "/assets/responsive-frontend/";